export class FileModel {

  static TYPE_IMAGE = 'image';
  static TYPE_VIDEO = 'video';

  static STATUS_QUEUE = 'waiting';
  static STATUS_PROGRESS = 'uploading';
  static STATUS_PROCESSING = 'processing';
  static STATUS_UPLOADED = 'uploaded';
  static STATUS_FAILED = 'failed';

  static CHUNK_SIZE = 1000000; // in bytes

  file: File;
  name: string;
  type: string;
  status: string = FileModel.STATUS_QUEUE;
  loadedChunks: number = 0;
  progress: number = 0;

  constructor(file: File, type: string) {
    this.file = file;
    this.name = Math.random().toString().replace('0.', '');
    this.type = type;
  }
}


// WEBPACK FOOTER //
// /code/frontend/src/app/shared/models/file.model.ts